import { API } from "../../api";
async function shipping_rates(request) {
    return await new API().apiPost({
        baseUrl: process.env.LETS_TRADE_INTEGRATION_URL ?? "",
        endpoint: `v1/starshipit/rates`,
        content: request,
    });
}
export { shipping_rates };
